<template>
  <code-scanner @onDetected="detected" :readerTypes="readerTypes" />
</template>

<script>
import CodeScanner from 'theme/components/CodeScanner/CodeScanner'
import { toast } from 'theme/modules/notifications'
import { localizedByName } from '@/filters/routers'

export default {
  name: 'EanScanner',
  data () {
    return {
      readerTypes: [
        'ean_reader'
      ]
    }
  },
  methods: {
    generateProductUrlKey (urlKey) {
      let path = '/'
      // width category path
      if (this.$store.state.category.current && this.$store.state.category.current.url_path) {
        path += this.$store.state.category.current.url_path + '/'
      }
      return localizedByName('factoryPage', this.$store, this.$router) + path + urlKey
    },
    detected (data) {
      this.$store.commit('ui/showLoader')
      const noResultMessage = this.$t('no-products-found')
      // search for barcode
      let barCode = data.codeResult.code
      this.$store.commit('ui/setBottomActiveComponent', {})
      this.$store.commit('ui/showLoader')
      return this.$store.dispatch('search/searchProductEan', { ean: barCode })
        .then((res) => {
          // find url key
          if (res && res.items && res.items.length) {
            // usually response contain only 1 result
            // if > 1 add query to search on listing
            if (res.items.length > 1) {
              console.log('todo -> multiple result on ean')
            }

            let product = res.items[0]
            if (product && product.url_key) {
              this.$store.commit('quickBuy/setToggle', true)
              this.$store.commit('quickBuy/setCurrentProductUrlKey', this.generateProductUrlKey(product.url_key))
              return true
            } else {
              toast.error(noResultMessage)
              return false
            }
          } else {
            toast.error(noResultMessage)
            return false
          }
        })
        .finally(() => {
          this.$store.commit('ui/hideLoader')
        })
    }
  },
  components: {
    CodeScanner
  }
}
</script>
